export default "__VITE_ASSET__DHkzyRC___"